import showMutationError from "@/lib/showMutationError";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BUG_SUGGESTION_URL = `${(import.meta as any ).env.VITE_API_URL}/bugs/report`;

// Interface matching your backend reportBugSchema payload
interface BugReportPayload {
  reportedByUserId?: number | null;
  title: string;
  description: string;
  severity?: string | null;
}

export const useReportBug = () => {
  return useMutation({
    mutationFn: async (payload: BugReportPayload) => {
      const response = await axios.post(BUG_SUGGESTION_URL, payload);
      return response.data;
    },
    onSuccess: (_, variables) => {
      toast.success("Report submitted successfully");
      console.log("Success report: ", variables);
    },
    onError: showMutationError("Error reporting issue."),
  });
};
